import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import { disableCourt } from "../../../api/endpoint";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";
import axios from "axios";
import toast from "react-hot-toast";

const RemoveCourtModal = ({ isRemoveOpen, closeRemoveModal, selectedCourt, fetchCourts }) => {
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login)

  const disableCourtCallback = async () => {
    try {
      setLoading(true);
      const response = await axios.put(disableCourt, null, {
        headers: { Authorization: `Bearer ${auth}` },
        params: { id: selectedCourt }
      })
      closeRemoveModal()
      toast.success('Court disabled successfully')
      fetchCourts()
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader />}
      <Modal show={isRemoveOpen} onHide={closeRemoveModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Disable Court</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want disable this court?</Modal.Body>
        <Modal.Footer>
          <Button text="Disable" callBack={disableCourtCallback} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RemoveCourtModal;
